<div class="payment-processing-container">
  <h2 class="page-title">Payment Processing</h2>

  <!-- ===================== Kapcharge ===================== -->
  <div *ngIf="isLoading" class="loading-wrapper">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <ng-container *ngIf="!isLoading">
    <!-- Submission Toggle -->
    <form [formGroup]="generalForm" (ngSubmit)="onSaveGeneral()" autocomplete="off">
      <mat-card class="content-card config-section">
        <mat-card-header>
          <mat-card-title>Kapcharge &mdash; Submission</mat-card-title>
          <mat-card-subtitle>Enable automatic submission of pending transactions to Kapcharge</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <formly-form [form]="generalForm" [fields]="generalFields" [model]="generalModel"></formly-form>
        </mat-card-content>
        <mat-card-actions align="end">
          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="generalForm.invalid || isSavingGeneral">
            <mat-spinner *ngIf="isSavingGeneral" diameter="20" class="btn-spinner"></mat-spinner>
            <span *ngIf="!isSavingGeneral">Save</span>
          </button>
        </mat-card-actions>
      </mat-card>
    </form>

    <!-- Webhook Configuration -->
    <form [formGroup]="webhookForm" (ngSubmit)="onSaveWebhook()" autocomplete="off">
      <mat-card class="content-card config-section">
        <mat-card-header>
          <mat-card-title>Kapcharge &mdash; Webhook Configuration</mat-card-title>
          <mat-card-subtitle>Configure Kapcharge webhook notifications</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <formly-form [form]="webhookForm" [fields]="webhookFields" [model]="webhookModel"></formly-form>
        </mat-card-content>
        <mat-card-actions align="end">
          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="webhookForm.invalid || isSavingWebhook">
            <mat-spinner *ngIf="isSavingWebhook" diameter="20" class="btn-spinner"></mat-spinner>
            <span *ngIf="!isSavingWebhook">Save Webhook</span>
          </button>
        </mat-card-actions>
      </mat-card>
    </form>
  </ng-container>

  <!-- ===================== Payments Canada: FIF Branch Cache ===================== -->
  <mat-card class="content-card config-section">
    <mat-card-header>
      <mat-card-title>Payments Canada &mdash; FIF Branch Cache</mat-card-title>
      <mat-card-subtitle>
        Upload the 3 Payments Canada numeric-list PDFs (Banks, Trust Companies, Credit Unions /
        Caisses Populaires). Submitting clears the branch cache and re-inserts every parsed record.
        Download the latest PDFs from the
        <a
          href="https://www.payments.ca/payment-resources/directories?field_directory_type=11"
          target="_blank"
          rel="noopener noreferrer">
          Payments Canada directories
        </a>
        (Financial Institutions File &mdash; Numeric List).
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="fif-upload-list">
        <div *ngFor="let field of fifUploadFields; let i = index" class="fif-upload-row">
          <span class="fif-upload-label">{{ field.label }}</span>

          <input
            type="file"
            accept="application/pdf"
            hidden
            #fileInput
            (change)="onFifFileSelected(i, $event)" />

          <button
            mat-stroked-button
            color="primary"
            type="button"
            [disabled]="isUploadingFif"
            (click)="fileInput.click()">
            <mat-icon>upload_file</mat-icon>
            Choose PDF
          </button>

          <span class="fif-upload-filename" [class.placeholder]="!fifFiles[i]">
            {{ fifFiles[i]?.name || 'No file selected' }}
          </span>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions align="end">
      <button
        mat-raised-button
        color="primary"
        type="button"
        [disabled]="!canUploadFif"
        (click)="onUploadFif()">
        <mat-spinner *ngIf="isUploadingFif" diameter="20" class="btn-spinner"></mat-spinner>
        <span *ngIf="!isUploadingFif">Submit</span>
      </button>
    </mat-card-actions>
  </mat-card>
</div>